module.exports = __webpack_public_path__ + "img/u156.340c3f7a.svg";